


import axios, { AxiosResponse } from 'axios';
import {Response, ApiResponse} from '../../interface/IResponse';


import {ResponseLoanManagementTableData, TypeOfLoanListResponse, 
        ResponseNumberDataResponse, ResponseMemberLoanDetails, 
        CreateLoanInput, ResponseLoanStatusDetails, ResponseBorrowerLoansDetail,
        LoanTermAmortizationPaymentInput, InterestRate, UpdateLoanApplicationDetailsInput, ApproveLoanInput, 
        UpdateLoanStatusInput, ResponsePdfFile} from '../../interface/ILoanManagement';
import { Try } from '@mui/icons-material';




async function listLoanManagementFunction() : Promise<AxiosResponse<ResponseLoanManagementTableData>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getLoanManagementList";

        const response: AxiosResponse<ResponseLoanManagementTableData> = await axios.get<ResponseLoanManagementTableData>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}

async function listTypeOfLoanFunction() : Promise<AxiosResponse<TypeOfLoanListResponse>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getTypeOfLoansList";

        const response: AxiosResponse<TypeOfLoanListResponse> = await axios.get<TypeOfLoanListResponse>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}

async function getInterestRatesValueFunction(typeOfLoanId:number) : Promise<AxiosResponse<ResponseNumberDataResponse>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getInterestRatesValue/" + typeOfLoanId;

        const response: AxiosResponse<ResponseNumberDataResponse> = await axios.get<ResponseNumberDataResponse>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}

async function getLoanTermsFunction() : Promise<AxiosResponse<ResponseNumberDataResponse>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getLoanTerms";

        const response: AxiosResponse<ResponseNumberDataResponse> = await axios.get<ResponseNumberDataResponse>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}


async function getMemberLoanDetailsFunction(membershipId:string) : Promise<AxiosResponse<ResponseMemberLoanDetails>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getMemberLoanDetails/" + membershipId;

        const response: AxiosResponse<ResponseMemberLoanDetails> = await axios.get<ResponseMemberLoanDetails>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}


async function getMemberLoanDetailsByMemberIdFunction(memberId:string) : Promise<AxiosResponse<ResponseMemberLoanDetails>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getMemberLoanDetailsByMemberId/" + memberId;

        const response: AxiosResponse<ResponseMemberLoanDetails> = await axios.get<ResponseMemberLoanDetails>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}


async function createLoanFunction(input: CreateLoanInput) : Promise<AxiosResponse<Response>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/createLoan";

        var response : AxiosResponse<Response> = await axios.post(apiUrl, input, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
         if(axios.isAxiosError(error)){

                throw error.response?.data.message;
            }
            else{
                throw error;
            }
    }
}

async function getLoanStatusDetailsFunction(loanId: number) : Promise<AxiosResponse<ResponseLoanStatusDetails>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getLoanStatusDetails/"+ loanId;

        var response : AxiosResponse<ResponseLoanStatusDetails> = await axios.get(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
         if(axios.isAxiosError(error)){

                throw error.response?.data.message;
            }
            else{
                throw error;
            }
    }
}

async function getBorrowerLoansDetailFunction(memberId: number) : Promise<AxiosResponse<ResponseBorrowerLoansDetail>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getBorrowerDetails/"+ memberId;

        var response : AxiosResponse<ResponseBorrowerLoansDetail> = await axios.get(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
         if(axios.isAxiosError(error)){

                throw error.response?.data.message;
            }
            else{
                throw error;
            }
    }
}


async function loanTermAmortizationPaymentFunction(input: LoanTermAmortizationPaymentInput) : Promise<AxiosResponse<Response>>{

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/loanTermAmortizationPayment";

        var response : AxiosResponse<Response> = await axios.post(apiUrl, input, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials : true
        });

        return response;
    }
    catch(error){
         if(axios.isAxiosError(error)){

                throw error.response?.data.message;
            }
            else{
                throw error;
            }
    }

} 

async function getInterestRateTermsByTypeOfLoanFunction(typeOfLoanId:number) : Promise<AxiosResponse<ApiResponse<InterestRate[]>>>{
    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/getInterestRateTermsByTypeOfLoan/" + typeOfLoanId;

        const response: AxiosResponse<ApiResponse<InterestRate[]>>= await axios.get<ApiResponse<InterestRate[]>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){

               throw error.response?.data.message;

           }
           else{
               throw error;
           }
   }
}

async function updateLoanApplicationDetailsFunction(loanId: number, input: UpdateLoanApplicationDetailsInput): Promise<AxiosResponse<Response>> {
    try {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/updateLoanApplicationDetails/" + loanId;

        var response: AxiosResponse<Response> = await axios.put(apiUrl, input, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });

        return response;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            throw error.response?.data.message;
        }
        else {
            throw error;
        }
    }
}

async function approveLoanFunction(loanId: number, input: ApproveLoanInput): Promise<AxiosResponse<Response>> {
    try {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/approveLoan/" + loanId;

        var response: AxiosResponse<Response> = await axios.put(apiUrl, input, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });

        return response;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            throw error.response?.data.message;
        }
        else {
            throw error;
        }
    }
}

async function declineLoanApplicationFunction(loanId: number): Promise<AxiosResponse<Response>> {
    try {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/declineLoanApplication/" + loanId;

        var response: AxiosResponse<Response> = await axios.put(apiUrl, {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });

        return response;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            throw error.response?.data.message;
        }
        else {
            throw error;
        }
    }
}

async function generateLoanApplicationFormPdfFunction(loanId: number): Promise<AxiosResponse<ResponsePdfFile>> {
    try {
        var apiUrl = process.env.REACT_APP_API_URL + "/LoanReport/generateLoanApplicationFormPdf/" + loanId;

        var response: AxiosResponse<ResponsePdfFile> = await axios.get(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });

        return response;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            throw error.response?.data.message;
        }
        else {
            throw error;
        }
    }
}

async function updateLoanStatusFunction(loanId: number, input: UpdateLoanStatusInput): Promise<AxiosResponse<Response>> {
    try {
        var apiUrl = process.env.REACT_APP_API_URL + "/Loan/updateLoanStatus/" + loanId;

        var response: AxiosResponse<Response> = await axios.put(apiUrl, input, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });

        return response;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            throw error.response?.data.message;
        }
        else {
            throw error;
        }
    }
}


const loanManagementService = {
    listLoanManagement : listLoanManagementFunction,
    listTypeOfLoan : listTypeOfLoanFunction,
    getInterestRatesValue : getInterestRatesValueFunction,
    getLoanTerms : getLoanTermsFunction,
    getMemberLoanDetails : getMemberLoanDetailsFunction,
    createLoan: createLoanFunction,
    getLoanStatusDetails: getLoanStatusDetailsFunction,
    getMemberLoanDetailsByMemberId: getMemberLoanDetailsByMemberIdFunction,
    getBorrowerLoansDetail: getBorrowerLoansDetailFunction,
    loanTermAmortizationPayment: loanTermAmortizationPaymentFunction,
    getInterestRateTermsByTypeOfLoan: getInterestRateTermsByTypeOfLoanFunction,
    updateLoanApplicationDetails: updateLoanApplicationDetailsFunction,
    approveLoan: approveLoanFunction,
    declineLoanApplication: declineLoanApplicationFunction,
    generateLoanApplicationFormPdf: generateLoanApplicationFormPdfFunction,
}

export default loanManagementService;